import {SagaIterator} from "redux-saga";
import {spawn} from "redux-saga/effects";
import iceClientSaga from "./iceClient";
import sessionSaga from "./session";
import loginRoutingSaga from "./loginRouting";
import routesSaga from "../routes/saga";


export default function* rootSaga(): SagaIterator {
  yield spawn(iceClientSaga);
  yield spawn(sessionSaga);
  yield spawn(loginRoutingSaga);
  yield spawn(routesSaga);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/index.ts